import { createSlice } from '@reduxjs/toolkit';

import axios from 'axios';
import messageHandler from 'utils/messageHandler';

const rolSlice = createSlice({
  name: 'roles',
  initialState: {
    data: [],
    rolesById: {}
  },
  reducers: {
    setRoles: (state, { payload }) => {
      state.data = payload;
    },
    setRolesById: (state, { payload }) => {
      state.rolesById = {
        ...state.rolesById,
        [payload.id]: payload
      };
    }
  }
});

export const { setRoles, setRolesById } = rolSlice.actions;

export const getRoles = () => async dispatch => {
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_SERVER}/roles`);

    dispatch(setRoles(data));
  } catch (e) {
    console.log(e);
  }
};

export const getRolByRealEstate = id => async dispatch => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/roles/realEstate/${id}`
    );

    dispatch(setRoles(data));
  } catch (e) {
    console.log(e);
  }
};

export const createRol = (nuevoRol, realEstate) => async () => {
  try {
    const newRol = {
      name: nuevoRol.nombre,
      permissionIds: []
    };
    const cleanFalses = object => {
      for (let key in object) {
        object[parseInt(key)] ? newRol.permissionIds.push(key) : null;
      }
    };
    cleanFalses(nuevoRol?.permisos);

    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/roles/${realEstate}`,
      newRol
    );

    messageHandler('success', data.message);
  } catch (e) {
    messageHandler('error', e.response?.data?.message);
  }
};

export const deleteRol = id => async () => {
  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_SERVER}/roles/${id}`
    );

    messageHandler('success', data.message);
  } catch (e) {
    messageHandler('error', e.response);
  }
};

export const getRolById = id => async dispatch => {
  try {
    const { data } = axios.get(`${process.env.REACT_APP_SERVER}/roles/${id}`);
    dispatch(setRolesById(data));
  } catch (e) {
    console.log(e);
  }
};

export const getRolByIdPublic = id => async dispatch => {
  try {
    const { data } = axios.get(
      `${process.env.REACT_APP_SERVER}/users/get-user-permissions/${id}`
    );

    dispatch(setRolesById(data));
  } catch (e) {
    console.log(e);
  }
};

export const editRol =
  ({ id, inmobiliaria, nombre, permisos }) =>
  async () => {
    try {
      const rolData = {
        roleId: id,
        name: nombre,
        permissionIds: []
      };
      const cleanFalses = object => {
        for (let key in object) {
          object[parseInt(key)] ? rolData.permissionIds.push(key) : null;
        }
      };
      cleanFalses(permisos);

      const { data } = await axios.patch(
        `${process.env.REACT_APP_SERVER}/roles/${inmobiliaria}`,
        rolData
      );

      messageHandler('success', data.message);
    } catch (e) {
      messageHandler('error', e.response?.data?.message);
    }
  };

export default rolSlice.reducer;
